import { render, staticRenderFns } from "./ThinSpan.vue?vue&type=template&id=78debad0&scoped=true"
import script from "./ThinSpan.vue?vue&type=script&lang=js"
export * from "./ThinSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78debad0",
  null
  
)

export default component.exports